// EtiquetasXL templates catalogo - S48.1 / S48.2a / S48.2b.
// Catalogo de plantillas oficiales. S48.2b agrega tecnica_bundle.
import individual from './individual.json';
import bundleDemo from './bundle_demo.json';
import tecnicaIndividual from './tecnica_individual.json';
import tecnicaBundle from './tecnica_bundle.json';

export const TEMPLATES = [
  individual,
  bundleDemo,
  tecnicaIndividual,
  tecnicaBundle,
];

export function findTemplate(id) {
  if (!id) return null;
  for (let i = 0; i < TEMPLATES.length; i += 1) {
    if (TEMPLATES[i].id === id) return TEMPLATES[i];
  }
  return null;
}
